import { Dispatch, SetStateAction } from "react";
import { DETAILS_TABS } from "../../data";
import { COMPACT_QUERY } from "../../../../utils/hooks/useCompact";
import Box from "@mui/material/Box";

const compact = "@media " + COMPACT_QUERY;

interface CashSalesTabsProps {
  statusTab: string;
  setStatusTab: Dispatch<SetStateAction<string>>;
}

export default function CashSalesDetailsTabs({
  statusTab,
  setStatusTab,
}: CashSalesTabsProps) {
  return (
    <Box
      sx={{
        width: "25%",
        display: "flex",
        alignItems: "end",
        overflow: "hidden",
      }}
    >
      {DETAILS_TABS.map((tab, index) => (
        <Box
          key={tab.value}
          onClick={() => setStatusTab(tab.value)}
          sx={{
            flex: 1,
            height: 60,
            // height: tab.value === statusTab ? 70 : 60,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            fontWeight: tab.value === statusTab ? "bold" : 500,
            color: tab.value === statusTab ? "#fff" : "#606060",
            bgcolor: tab.value === statusTab ? "#5C69E8" : "#fff",
            fontSize: 18,
            [compact]: { height: 48, fontSize: 16 },
            border: (theme) => `1px solid ${theme.palette.draft.main}`,
            borderRadius:
              tab.value === statusTab
                ? "12px 12px 0 0"
                : index === 0
                ? "12px 0 0 0"
                : index === DETAILS_TABS.length - 1
                ? "0 12px 0 0"
                : "0",
          }}
        >
          {tab.label}
        </Box>
      ))}
    </Box>
  );
}
